/**
 * Prompt beta users can paste into Cursor when open disagreements exist.
 * Reviews portal.scam_check_feedback and updates heuristics / system prompt.
 */
export const SCAM_HEURISTIC_FIX_PROMPT = `Review portal.scam_check_feedback for OPEN disagreements only (resolution_status = 'open')
between user_label (scam|not_scam) and predicted_risk:
  scam vs low/medium/unknown, or not_scam vs high/medium.
Focus on repeated patterns (same heuristic_codes, brands, lure phrases, or link hosts).
If there are enough clear disagreements to justify a change, update
apps-portal/api/app/services/ai_scam_check.py heuristics and/or _SYSTEM_PROMPT accordingly.
Add regression tests in apps-portal/api/tests/test_ai_scam_check.py from anonymized or
synthetic reproductions of those patterns.
After shipping the fix, mark the disagreement rows you addressed as resolution_status = 'resolved'
(set resolved_at, short resolution_note). Leave unrelated open rows alone.
Do not delete feedback rows — embeddings still use them for RAG.
Do not change the RAG/feedback plumbing unless required for the fix.
Summarize what you changed, which clusters you resolved, and which open disagreements remain.`;
